import { getConfig } from "@jti/fe-common";
const addHashQueryParam = (url, searchParamName, searchParamValue) => {
    const searchParamIndex = url.lastIndexOf("?");
    const existing = searchParamIndex > url.lastIndexOf("#") ? url.substr(searchParamIndex + 1) : "";
    const query = new URLSearchParams(existing);
    query.set(searchParamName, searchParamValue);
    return `${url.replace(`?${existing}`, "")}?${query.toString()}`;
};
export const getRedirectionConfigurationUrl = (url, redirectToAuthPage, isLogged) => {
    const config = getConfig();
    if (url) {
        return `${url}${redirectToAuthPage ? "#login" : ""}`;
    }
    if (!isLogged) {
        return `${config.AUTH_PAGE_URL}#login`;
    }
    return config.REDIRECT_AFTER_LOGIN_URL;
};
export const getRedirectionUrl = (url, redirectToAuthPage, isLogged) => {
    const currentUrlString = getRedirectionConfigurationUrl(url, redirectToAuthPage, isLogged);
    try {
        const currentUrl = new URL(currentUrlString, window.location.origin);
        return addHashQueryParam(currentUrl.href, "returnUrl", window.location.href);
    }
    catch (e) {
        return currentUrlString;
    }
};
//# sourceMappingURL=helpers.js.map